import { BadgeAccountAlertIcon } from './BadgeAccountAlertIcon';

/**
 * author: Michael Richins
 * id 610A9983-6737-4876-B1E2-09C22D3888D9
 * name badge-account-alert
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/badge-account-alert.svg
 * tags
 * - Account / User 
 * - Alert / Error 
 */
export const AccountBadgeWarningIcon = BadgeAccountAlertIcon;
export default AccountBadgeWarningIcon